import { guid4, ROOT_OUTPUT } from 'shared-base';

export const generatorToModel = (generator: IGenerator, palettes: IPalette[]) => {
  const guid = guid4();

  const { name, paletteId, defaultValues = {} } = generator;
  let materials = {};

  if (paletteId) {
    const palette = Object.values(palettes).find((p) => p.id === paletteId);

    materials = palette?.materials ?? {};
  }

  const model = {
    id: guid,
    name,
    generatorId: generator.id,
    generatorUrl: `${ROOT_OUTPUT}/${generator.id}.template.json`,
    thumbnail: '',
    modifiedAt: new Date().toISOString(),
    valuesModel: { ...defaultValues, LOD: 0.5 },
    materials,
    paletteId,
  };

  return model as Partial<IModel>;
};
